<template>
  <!-- state thumbnail -->
  <div>
    <div
      v-if="mode === 'state'"
      class="thumbnail-state"
      :style="{backgroundColor: backgroundColor}">
      <div
        class="progress"
        :style="{width: progress + '%', backgroundColor: foregroundColor}" />

      <span class="icon-container">
        <slot name="icon" />
      </span>

      <span class="label">{{ text }}</span>
    </div>

    <div
      v-if="mode === 'time'"
      class="thumbnail-time">
      <span class="label">{{ text }}</span>
    </div>

    <!-- interactive thumbnail -->
    <div
      v-if="mode === 'interactive'"
      class="thumbnail-interactive"
      :style="{backgroundColor: backgroundColor}">
      <span class="icon-container">
        <slot name="icon" />
      </span>
      <span class="label">{{ text }}</span>
    </div>
  </div>
</template>

<script>
// Thumbnail types available
const modes = ['interactive', 'state', 'time']

export default {
  name: 'WptvThumbnail',
  props: {
    text: { // text in thumbnail
      type: String,
      required: true
    },
    mode: { // mode of thumbnail interactive|state
      type: String,
      required: true,
      validator: (value) => modes.includes(value)
    },
    progress: {
      type: Number,
      default: 0,
      validator: (value) => value >= 0 && value <= 100
    }, // progress percent
    foregroundColor: { // progress bar color
      type: String,
      default: '#FF7900'
    },
    backgroundColor: { // background color
      type: String,
      default: '#333333'
    }
  }
}
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @import '../../scss/abstracts/variables';

  .thumbnail-time {
    display: flex;
    position: absolute;
    max-width: 90%;
    white-space: nowrap;
    overflow: hidden;
    font-size: 14px;
    line-height: 1.43;
    left: 0;
    top: 0;
    color: #FFFFFF;
    background-color: #FF7900;
    z-index: 1;
    padding: 10px;
    font-weight: bold;
  }

  .thumbnail-state,
  .thumbnail-interactive {
    position: absolute;
    font-size: 14px;
    right: 0;
    top: 0;
    height: 22px;
    color: #000;
    background-color: #ffd200;
    text-align: left;
    line-height: 22px;
    font-weight: bold;
    white-space: nowrap;
    overflow: hidden;
    max-width: 90%;
    z-index: 1;
    display: flex;

    .icon-container {
      position: relative;
      line-height: 22px;
      display: inline-block;
      padding: 0 5px;
      z-index: 3;
      vertical-align: middle;
      font-size: 0.5em;
    }

    .label {
      position: relative;
      line-height: 22px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-weight: bold;
      display: inline-block;
      padding-right: 5px;
      z-index: 3;
      flex: 1;
      vertical-align: middle;
      flex-basis: auto;
    }

    .progress {
      position: absolute;
      background-color: map-get($wptv-palette, 'primary');
      height: 100%;
      top: 0;
      left: 0;
      transition: all 1s ease;
      z-index: 2;
    }
  }

  .wptv:not(.can-touch) {
    .thumbnail-interactive {
      max-width: 30px;
      transition: max-width 1s ease;
    }

    .item > *:hover,
    .wptv-poster:hover {
      .thumbnail-interactive {
        max-width: 90%;
        transition: max-width 1s ease;
      }
    }
  }

</style>
